<template>
  <validation-observer ref="observer" v-slot="{ invalid }">
    <interview-header :isShowCredit="isShowCredit" :title="title || ''" :creditCount="creditCount"/>

    <div class="page-view">
      <b-container class="p-0">
        <interview-route-change-modal :show-route-change-modal="layout.showRouteChangeModal" @leavePage="routerNext()"
          @stayPage="layout.showRouteChangeModal = false" />
        <b-row class="p-0 m-0">
          <b-col xs="12" sm="12" md="12" lg="12" xl="12" class="p-0">
            <div key="main">
              <validation-error :show="showValidationError" :isValid="isValid" :fileUploaded="fileUploaded" />
              <interview-detail-information key="detailInformation" :candidate="candidate" :invalid="invalid"
                :buttonLoading="buttonLoading"
                :fetch="fetch" :sendableCount="sendableCount" @onCheckValidRule="onValidateField" @checkAction="checkAction" :isValid="isValid"
                @checkAlertShow="onCheckAlertShow" :interviewType="interviewType"/>
            </div>
          </b-col>
          <div v-show="showModal" class="cst-modal-one">
            <div class="cst-container">
              <div class="cst-content" v-if="firstStep" :style="{'padding-top': '24px'}">
                <picture>
                  <img :src="require('@/assets/fileUpload/file_upload_takeNotes.svg')" alt="">
                </picture>
                <div class="loading-bar">
                  <div class="loading-bar__fill-part"></div>
                  <div class="loading-bar__empty-part"></div>
                </div>
                <div class="warning-area my-auto">
                  <div class="warning-area__head">{{ interviewType === 3 ? resource["hrvenue.createcandidate.sendingInterviewsInPersonTitle"] : resource["hrvenue.createcandidate.sendingInterviews"] }}</div>
                  <div class="warning-area__note" :style="{'margin-bottom': '0px !important'}">{{ interviewType === 3 ?  resource["hrvenue.createcandidate.sendingInterviewsInPersonDescription"] : resource["hrvenue.createcandidate.sendingInterviewsWarning"] }}</div>
                </div>
              </div>
              <div class="cst-header" v-if="!firstStep">
                  <span class="cursor-pointer" @click="showModal = !showModal">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18.2997 5.70997C17.9097 5.31997 17.2797 5.31997 16.8897 5.70997L11.9997 10.59L7.10973 5.69997C6.71973 5.30997 6.08973 5.30997 5.69973 5.69997C5.30973 6.08997 5.30973 6.71997 5.69973 7.10997L10.5897 12L5.69973 16.89C5.30973 17.28 5.30973 17.91 5.69973 18.3C6.08973 18.69 6.71973 18.69 7.10973 18.3L11.9997 13.41L16.8897 18.3C17.2797 18.69 17.9097 18.69 18.2997 18.3C18.6897 17.91 18.6897 17.28 18.2997 16.89L13.4097 12L18.2997 7.10997C18.6797 6.72997 18.6797 6.08997 18.2997 5.70997Z" fill="#333333"/>
                    </svg>
                </span>
              </div>
              <div class="cst-content" v-if="!firstStep">
                <picture>
                  <img :src="require('@/assets/fileUpload/file_upload_takeNotes.svg')" alt="">
                </picture>
                <div class="warning-area">
                  <div class="warning-area__head">{{ interviewType === 3 ? resource["hrvenue.createcandidate.sendedInterviewsInPersonTitle"] : resource["hrvenue.createcandidate.sendedInterviews"]}}</div>
                  <div class="warning-area__note">{{ interviewType === 3 ?  resource["hrvenue.createcandidate.sendedInterviewsInPersonDescription"] : resource["hrvenue.createcandidate.sendedRelatedInterviews"] }}</div>
                </div>
                  <button @click="goToInterviewsPage"
                class="btn with-icon bg-purple text-white btn-goTo"
                id="closeFileUploadModal"
                name="closeFileUploadModal"
              >{{ interviewType === 3 ? resource["hrvenue.createcandidate.browseNow"] : resource["hrvenue.createcandidate.goToInterviewsPage"]}}</button>
              </div>
            </div>
          </div>
        </b-row>
      </b-container>
    </div>
    <b-modal v-model="rightModal" id="modal-center" centered hide-footer modal-class="new-modal">
      <div slot="modal-header" class="d-flex justify-content-end w-100">
        <i class="icon-close custom-modal-close cursor-pointer" @click="rightModal = false" />
      </div>
      <div class="d-flex align-items-center justify-content-center flex-column w-100">
        <img src="/images/upgrade.svg" loading="lazy" alt="upgrade">
        <h2>{{rightPopupTitle}}</h2>
        <p>{{rightPopupDescription}}</p>
        <div class="w-100 d-flex justify-content-between gap-3">
          <b-button
            name="cancel"
            class="border-button-create"
            @click="rightModal = false"
          >
            {{ resource["upgradePopupCancel"] }}
          </b-button>
          <b-button
            name="upgrade"
            class="bg-button gap-2 d-flex align-items-center"
            @click="routePricing()"
          >
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
            <path d="M8.49956 11.6797L11.2662 13.3531C11.7729 13.6597 12.3929 13.2064 12.2596 12.6331L11.5262 9.4864L13.9729 7.3664C14.4196 6.97973 14.1796 6.2464 13.5929 6.19973L10.3729 5.9264L9.11289 2.95307C8.88623 2.41307 8.11289 2.41307 7.88623 2.95307L6.62623 5.91973L3.40623 6.19307C2.81956 6.23973 2.57956 6.97306 3.02623 7.35973L5.47289 9.47973L4.73956 12.6264C4.60623 13.1997 5.22623 13.6531 5.73289 13.3464L8.49956 11.6797Z" fill="white"/>
          </svg>
          {{rightPopupSubmit}}
          </b-button>
        </div>
      </div>
    </b-modal>
  </validation-observer>
</template>

<script>
import HrVenueService from '@/services/hrvenue.service';
import { showNotification } from '@/static/helpers';

export default {
  name: 'InterviewCreate',

  components: {
    interviewDetailInformation: () => import('./interviewCreateComponents/interviewDetailInformation.vue'),
    interviewHeader: () => import('./interviewCreateComponents/interviewHeader.vue'),
    interviewRouteChangeModal: () => import('./interviewCreateComponents/interviewRouteChangeModal.vue'),
    ValidationError: () => import('../common/infos/ValidationError.vue'),
  },

  data() {
    return {
      interviewType: 0,
      interviewId: '',
      loadingStack: {},
      routerNext: null,
      sendableCount: 0,
      showModal: false,
      firstStep: true,
      fetch: true,
      layout: {
        showRouteChangeModal: false,
        isSubmit: false,
      },
      candidate: {},
      oldCandidate: {},
      candidatesList: [],
      title: '',
      isValid: false,
      showValidationError: true,
      fileUploaded: false,
      creditCount: '',
      isCreated: true,
      buttonLoading: false,

      rightModal: false,
      companyPackageInfo: {},
      companyTrialPackageIsExpired: null,
      rightModalReason: null,
      bulkSendRight: null,
    };
  },

  computed: {
    isShowCredit() {
      return this.creditCount > -1;
    },

    rightPopupTitle() {
      let reason = '';
      switch (this.rightModalReason) {
        case 1:
          reason = this.resource.upgradePopupNotEnoughCredit; // 'Yeterli Kredi yok'
          break;
        case 2:
          reason = this.resource.upgradePopupNotBulkSend; // 'Toplu gönderim yok';
          break;
        default:
          break;
      }

      return reason;
    },

    rightPopupDescription() {
      let message = '';
      if (this.companyPackageInfo === null) {
        if (this.companyTrialPackageIsExpired === null) {
          message = this.resource.companyTrialPackageNotStartDescription;
        } else if (this.companyTrialPackageIsExpired) {
          message = this.resource.companyTrialPackageExpiredDescription;
        } else {
          message = this.resource.companyTrialPackageExpiredNotRightDescription;
        }
      } else {
        message = this.resource.companyPackageNotRightDescription;
      }

      return message;
    },

    rightPopupSubmit() {
      if (this.companyPackageInfo === null && this.companyTrialPackageIsExpired === null) {
        return this.resource.upgradePopupStart;
      }
      return this.resource.upgradePopupSubmit;
    },
  },
  async created() {
    await this.getCredit();
    await this.getCompanyPackageInfo();
    await this.getCompanyTrialPackageInfo();
    await this.getCompanyBulkSendRight();
    const { interviewId } = this.$route.params;
    const { interview } = await HrVenueService.getInterview(interviewId);
    this.interviewId = interviewId;
    this.interviewType = interview.type;
    if (!this.interviewId) {
      showNotification(
        this.resource['Label.Warning'],
        this.resource['interviewCreate.InterviewIdCanNotBeNull'],
        'warning',
      );
      this.goToInterviewsPage();
    }
    this.title = interview.name;
    this.candidate = {
      candidates: [{}],
    };
    this.isCreated = false;
  },
  async mounted() {
    const { sendableCount } = await HrVenueService.getSendableCount();
    this.sendableCount = sendableCount;
    // this.$refs.observer.validate();
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isCreated) {
      next();
    } else if (!this.layout.isSubmit) {
      const equal = this.candidate.candidates.some((candidate) => candidate.name || candidate.surname || candidate.email);
      if (!equal) {
        next();
      } else {
        this.layout.showRouteChangeModal = true;
        this.routerNext = next;
        next(false);
      }
    } else {
      next();
    }
  },

  methods: {
    async getCredit() {
      const { totalUsableRight } = await HrVenueService.getCreditRight();
      this.creditCount = totalUsableRight >= 0 ? totalUsableRight : 0;
    },
    routePricing() {
      this.rightModal = false;
      this.isCreated = true;
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'PricingListView', params: { lang } });
    },

    async getCompanyPackageInfo() {
      const response = await HrVenueService.getCompanyPackage();
      this.companyPackageInfo = response;
    },

    async getCompanyTrialPackageInfo() {
      const response = await HrVenueService.getCompanyTrialPackageInfo();
      this.companyTrialPackageIsExpired = response.trialPackageIsExpired;
    },

    async getCompanyBulkSendRight() {
      const response = await HrVenueService.getRight(8);
      this.bulkSendRight = response;
    },
    checkValidAllField() {
      let isValid = false;
      for (let i = 0; i < this.candidate.candidates.length; i += 1) {
        if (!this.validateFields(this.candidate.candidates[i])) {
          isValid = true;
          this.$refs.observer.validate();
          break;
        }
      }
      return isValid;
    },
    validateFields(obj) {
      if (!(obj.name || obj.email || obj.surname)) {
        return false;
      }
      const validEmail = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(obj.email);
      const validLength = (obj.name && obj.name.length >= 2 && obj.surname && obj.surname.length >= 2 && obj.email && obj.email.length >= 10);
      if (validEmail && validLength) {
        return true;
      }
      return false;
    },
    onValidateField() {
      this.isValid = this.checkValidAllField();
    },
    async checkAction(dateRange, isSchedule) {
      const isValid = await this.$refs.observer.validate();
      if (typeof isValid !== 'undefined' && isValid) {
        const validationMessage = this.validateCandidates();
        if (validationMessage) {
          showNotification(
            this.resource['label.Error'],
            validationMessage,
            'error',
          );
          return false;
        }
        const candidateLength = this.candidate.candidates.length;
        if (candidateLength > 1 && (!this.bulkSendRight || this.bulkSendRight.totalUsableRight === 0)) {
          this.rightModal = true;
          this.rightModalReason = 2; // bulk send not enough
          return false;
        }

        if (candidateLength > this.creditCount) {
          this.rightModal = true;
          this.rightModalReason = 1; // credit not enough
          return false;
        }

        this.submitCandidate(dateRange, isSchedule);
      }
    },
    onCheckAlertShow(val) {
      this.showValidationError = !val;
      this.fileUploaded = val;
    },
    validateCandidates() {
      if (this.candidate.candidates.length < 1) {
        return 'Mülakat oluştururken soru alanını boş bıraktınız. Lütfen sorunuzu ekleyin.';
      }

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.candidate.candidates.length; i++) {
        const candidate = this.candidate.candidates[i];
        if (!candidate.name || !candidate.surname || !candidate.email) {
          return 'Lütfen tüm zorunlu alanları doldurunuz.';
        }
      }

      const candidates = this.candidate.candidates;
      const sameEmailControl = candidates.some((item, index) => candidates.some(
        (item2, index2) => item2.email === item.email && index !== index2,
      ));
      if (sameEmailControl) {
        return this.resource['hrvenue.createcandidate.samecandidateerMessage'];
      }

      return '';
    },
    sendableStatusShow(candidatesList) {
      const beforeSendedCandidatesEmail = [];
      candidatesList.forEach((candidate) => { if (candidate.reasonForNotSending === 4) beforeSendedCandidatesEmail.push(candidate.email); });
      if (beforeSendedCandidatesEmail.length) {
        showNotification(
          this.resource['Label.Error'],
          `${this.resource['interviewCreate.AlreadySentEmail']} : ${beforeSendedCandidatesEmail.toString()}`,
          'error',
        );
      }
      return beforeSendedCandidatesEmail;
    },

    async submitCandidate(dateRange, isSchedule) {
      try {
        this.buttonLoading = true;
        if (this.candidate.candidates.length > this.sendableCount) {
          return showNotification(
            this.resource['Label.Error'],
            this.resource['candidateDetail.candidateNumberExceedError'],
            'error',
          );
        }

        const validationMessage = this.checkValidAllField();
        if (validationMessage) {
          return false;
        }
        this.loadingStack.detail = true;
        if (!this.candidate.id) {
          const { candidates } = await HrVenueService.checkInterviewSendableStatus(
            this.interviewId,
            this.candidate.candidates,
            isSchedule,
            dateRange.startDate,
            dateRange.endDate,
          );
          if (candidates) {
            if (!this.sendableStatusShow(candidates).length) {
              this.showModal = true;
              const { sent } = await HrVenueService.sendInterviewOk(
                this.interviewId,
                this.candidate.candidates,
                isSchedule,
                dateRange.startDate,
                dateRange.endDate,
              );
              if (sent) {
                this.getCredit();
                this.firstStep = false;
                this.layout.isSubmit = true;
              } else {
                this.firstStep = true;
                this.showModal = false;
                this.layout.isSubmit = false;
                this.loadingStack = { detail: false };
              }
            }
          }
        }
        this.buttonLoading = false;
      } catch (error) {
        this.firstStep = true;
        this.showModal = false;
        showNotification(
          this.resource['Label.Error'],
          this.resource['interviewCreate.ProcessDuringError'],
          'error',
        );
      }
      this.loadingStack = { detail: false };
    },

    goToInterviewsPage() {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({
        name: 'HrVenueView',
        params: { lang },
      });
    },
  },
};
</script>

<style lang="scss">
@import '~@/style/starter.scss';

.cst-modal-one{
  position:fixed;
  height: 100%;
  left:0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(29, 29, 29, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4444;
  .cst-container{
    width: 372px;
    height: auto;
    background: #FFFFFF;
    border: 1px solid #E4E4E4;
    border-radius: 12px;
    padding: 0px;
    .cst-content{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0px 24px 24px 24px;
    }
    .cst-header{
      width: 100%;
      height: 36px;
      justify-content: flex-end;
      cursor: pointer;
      display: flex;
      padding: 12px 12px 0px;
    }
    >:last-child{
      .cst-header{
        display: flex;
      }
    }
  }
}
.loading-bar {
  position: relative;
  width: 218px;
  height: 8px;
  margin:16px 0;

  &__fill-part {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 132px;
    background: #FF8D06;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    animation: inserting 4s infinite linear;
  }

  &__empty-part {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 89px;
    background: #F5F5F5;
    border-radius: 20px;
    animation: removing 4s infinite linear;
  }
}
.btn-goTo{
  width: 100%;
  text-align: center;
  justify-content: center;
  border-radius: 50px;
  margin-bottom: 0px !important;
}
@keyframes inserting{
  0%{
    width: 132px;
  }
  100%{
      width: 100%;
  }
};
@keyframes removing{
  0%{
    width: 89px;
  }
  100%{
      width: 0;
  }
};
.warning-area{
  word-wrap: break-word;
  width: 100%;
  &__head{
    font-family: 'Roboto' !important;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    color: #1D1D1D;
    margin-top: 10px !important;
    margin-bottom: 8px !important;
  }
  &__note{
    font-family: 'Roboto' !important;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #878787;
    margin-bottom: 24px !important;

  }
}

.job-create-view {
  padding: 0 !important;

  .slide-enter-active {
    transition: all 0.3s ease;
  }

  .slide-leave-active {
    display: none;
  }

  .slide-enter,
  .slide-leave-to {
    opacity: 0;
  }
}

.new-modal {
  .modal-dialog {
    max-width: 372px;
  }
  .modal-content {
    border-radius: 12px;
  }

  .modal-header {
    border-bottom: 0;
    padding: 12px 12px 0px 12px;

    i {
      font-size: 24px;
      color: #333333;
    }
  }

  .modal-body {
    border-bottom: 0;
    padding: 0px 24px 24px 24px;

    img {
      margin-bottom: 14px;
    }

    h2 {
      color: #353535;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
      margin-bottom: 8px;
    }

    p {
      color: #858585;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 24px;
    }
  }

  .border-button-create {
    display: flex;
    flex: 1;
    padding: 9px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 114px;
    border: 1px solid #ff8d06;
    background: transparent !important;

    color: var(--main-colors-orange, #ff8d06);
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }

  .bg-button {
    display: flex;
    flex: 1;
    padding: 9px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 114px;
    border: 1px solid #ff8d06;
    background: #ff8d06;

    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }
}
</style>
